
const projects = [
    {
        id: 1,
        title: 'Camel Dispatcher Hardening',
        category: 'Stage',
        img: require('@/assets/images/Projects/project-1/Penarch-logo.png'),
        date: '16 September 2024 - 13 December 2024',
        client: {
            name: 'Pension Architects',
            services: 'Backend Development',
            website: 'https://www.pensionarchitects.be'
        },
        objective: 'Het verbeteren en optimaliseren van een dispatcher systeem bij Pension Architects. ' +
            'Dit omvat verbeteringen in foutafhandeling, berichtenverwerking en integratie in een administratief dashboard, met behulp van technologieën zoals AWS, Apache Camel en Java. ' +
            'Het doel is een robuuster, meer schaalbaar en gebruiksvriendelijk systeem te creëren.',
        technologies: ['Java', 'Apache Camel', 'AWS', 'Apache Tapestry', 'Shell'],
        projectDetails: [
            'Tijdens mijn stage bij Pension Architects heb ik gewerkt aan de optimalisatie van de dispatcher, een belangrijk onderdeel voor het stroomlijnen van gegevensverwerking binnen de organisatie. De opdracht richtte zich op vier hoofdlijnen: het implementeren van een gecontroleerde stopzetting (graceful shutdown), het herverwerken van berichten uit de Dead Letter Queue (redrive), het verbeteren van de foutafhandelingsprocedures en het vereenvoudigen van de lokale installatie van de dispatcher.',
            'De graceful shutdown werd geïmplementeerd met een timer van 5 minuten. Deze zorgt ervoor dat de dispatcher zichzelf afsluit zodra er 5 minuten geen berichten zijn. Dit voorkomt dat de dispatcher vastloopt wanneer er geen berichten meer worden verwerkt.',
            'Het herverwerken van berichten uit de Dead Letter Queue is essentieel voor de verbetering. Berichten die niet kunnen worden verwerkt, worden naar deze queue gestuurd en kunnen later opnieuw worden verwerkt, wat zorgt voor een betere gegevensverwerking.',
            'De foutafhandelingsprocedures werden opgedeeld in drie onderdelen: Ten eerste, de Latex errors, die vaak cryptisch waren, werden verbeterd door duidelijke foutmeldingen te implementeren, waardoor we snel en efficiënt konden ingrijpen. Ten tweede, werd de BacklogTracer toegevoegd, die het makkelijker maakt om de bron van fouten te traceren en te verhelpen. Ten derde, werd een systeem voor SFTP Pull errors ontwikkeld, dat de frequentie van foutmeldingen reduceert door alleen een melding te geven bij herhaalde fouten (meer dan vijf keer).',
            'Daarnaast heb ik de installatie van de lokale dispatcher vereenvoudigd, aangezien de documentatie daarvoor vaak incompleet was. Ik begon met het schrijven van gedetailleerde documentatie en ontwikkelde een script dat de installatie geautomatiseerd uitvoert, wat de efficiëntie van de installatie enorm verhoogt.',
            'De gebruikte technologieën in dit project omvatten AWS ECS, SQS, Apache Camel, Lambda Functions en Java. Als einddoel werden de functionaliteiten van het AWS-dashboard overgezet naar een adminpanel, wat het beheer van de dispatcher eenvoudiger en efficiënter maakt.'
        ],
        projectImages: [
            require('@/assets/images/Projects/project-1/Penarch-logo.png'),
            require('@/assets/images/Projects/project-1/Flowchart.png'),
            require('@/assets/images/Projects/project-1/Dispatcher.png')
        ],
        files: [
            {
                name: 'Plan van Aanpak',
                url: '/files/Plan-van-aanpak.pdf'
            },
            {
                name: 'Realisaties',
                url: '/files/Realisaties-Sian-Lauwers.pdf'
            },
            {
                name: 'Reflectie',
                url: '/files/Stage-Reflectie-Sian-Lauwers.pdf'
            }
        ]
    },
    {
        id: 2,
        title: 'Erasmus Oostenrijk',
        category: 'Erasmus',
        img: require('@/assets/images/Projects/project-2/Kasteel.jpg'),
        date: 'Oktober 2023 - Februari 2024',
        client: {
            name: 'FH Kufstein',
            services: 'Opleiding',
            website: 'https://www.fh-kufstein.ac.at/',
        },
        objective: 'Het opbouwen van zelfstandigheid, het uitbreiden van mijn kennis en het ontwikkelen van mijn persoonlijke en academische vaardigheden tijdens mijn Erasmus-uitwisseling in Oostenrijk.',
        technologies: ['HTML', 'CSS', 'JavaScript', 'Vue.js', 'TailwindCSS'],
        projectDetails: [
            'Tijdens mijn Erasmus-uitwisseling in Oostenrijk kreeg ik de kans om niet alleen mijn technische kennis en vaardigheden uit te breiden, maar ook om mijn persoonlijkheid en zelfstandigheid te ontwikkelen. Als Belg was Oostenrijk altijd al een plek die ik graag bezocht, en het leven daar bleek een bijzondere ervaring. Door deze reis kwam ik vaak mezelf tegen, wat me hielp groeien op zowel persoonlijk als professioneel vlak.',
            'Academisch gezien volgde ik een brede selectie aan vakken die mijn inzicht in informatica en technologie vergrootten. Elk vak bood unieke uitdagingen en leermomenten, zoals het bouwen van webapplicaties, het leren beheren van informatiesystemen en het ontwerpen van gebruiksvriendelijke interfaces. Daarnaast kreeg ik hands-on ervaring met innovatieve technieken zoals rapid prototyping en 3D-printing.',
            'Vakoverzicht van mijn Erasmus-ervaring:',
            '• Digital Media and The WEB',
            '• Fundamentals of Data Management',
            '• Information & Knowledge Retrieval',
            '• Information System Management',
            '• Project Management for Technical Projects',
            '• Rapid Product Development',
            '• Rapid Prototyping Technologies, 3D-Printing, Origami & Co',
            '• Simulation Modelling',
            '• Web & Mobile Usability',
            '• Web-Based Information Systems',
            'Over het algemeen heeft deze uitwisseling me geholpen om niet alleen mijn technische vaardigheden te verbeteren, maar ook om zelfstandig nieuwe uitdagingen aan te gaan. Het was een ervaring die me zowel professioneel als persoonlijk heeft verrijkt.'
        ],
        projectImages: [
            require('@/assets/images/Projects/project-2/Kasteel.jpg'),
            require('@/assets/images/Projects/project-2/School.jpg'),
            require('@/assets/images/Projects/project-2/Uitzicht.jpg')
        ],
        files: [
            {
                name: 'Paper Information en Knowledge Retrieval',
                url: '/files/Paper_information-knowledge-retrieval.pdf'
            },
            {
                name: 'Project Information System Management',
                url: '/files/Information-System-Management.pdf'
            },
            {
                name: 'Project Rapid Prototyping Technologies, 3D-Printing, Origami & Co',
                url: '/files/Project_Carousel.pdf'
            }
        ]
    },
    {
        id: 3,
        title: 'Vue.js Zero to Mastery',
        category: 'Online Cursus',
        img: require('@/assets/images/Projects/project-3/Vue.png'),
        date: '2024',
        client: {
            name: 'Zero To Mastery Academy',
            services: 'Vue.js Ontwikkelingstraining',
            website: 'https://www.udemy.com/course/complete-vue-js-developer-zero-to-mastery-vuex/',
        },
        objective: 'Het beheersen van Vue.js door middel van uitgebreide training, van fundamentele tot geavanceerde concepten. Waaronder Composition API, Pinia, Vue Router, Firebase integratie, en het bouwen van een full-stack Spotify-achtige muziekspeler applicatie.',
        technologies: ['Vue.js', 'Pinia', 'Firebase', 'Vitest', 'Sass', 'TailwindCSS', 'Composition API'],
        projectDetails: [
            'Een uitgebreide Vue.js cursus volledig gericht op het bouwen van moderne, efficiënte webapplicaties met de nieuwste Vue 3 technologieën en best practices.',
            'Een full-stack muziekspeler applicatie ontwikkeld vergelijkbaar met Spotify, met implementatie van functies zoals gebruikersauthenticatie, bestandsuploads, muziekweergave en internationalisatie.',
            'Praktische ervaring opgedaan met het Vue ecosysteem, waaronder Pinia voor state management, Vue Router voor navigatie en Firebase voor backend services.',
            'Geavanceerde concepten geleerd zoals aangepaste directives, transities & animaties, PWA-functionaliteiten en uitgebreide testing met Vitest.',
            'Moderne ontwikkelingsworkflows in praktijk gebracht, inclusief project optimalisatie, deployment strategieën en best practices voor het bouwen van schaalbare Vue applicaties.',
            'Alle cursusmodules succesvol afgerond en certificering behaald, wat mijn bekwaamheid in Vue.js ontwikkeling aantoont van fundamenteel tot geavanceerd niveau.',
            'Deze portfolio is ontwikkeld met behulp van de technologieën die ik tijdens de cursus heb verworven.'
        ],
        projectImages: [
            require('@/assets/images/Projects/project-3/Home.png'),
            require('@/assets/images/Projects/project-3/Song.png'),
            require('@/assets/images/Projects/project-3/Manage.png')
        ],
        files: [
            {
                name: 'Cursus Certificaat',
                url: '/files/vue-certificate.pdf'
            },
            {
                name: 'Cursus Master Project',
                url: 'https://music-example-sianlauwers-projects.vercel.app/#/'
            }
        ]
    },
    {
        id: 4,
        title: 'Job Application Training',
        category: 'PHP Project',
        img: require('@/assets/images/Projects/project-4/home.png'),
        date: '2022 - 2023',
        client: {
            name: 'Thomas More',
            services: 'UI Design & Frontend Development',
        },
        objective: 'Het ontwikkelen van een platform voor stagebeheer binnen de IT-opleiding van Thomas More College, waarbij studentregistratie, bedrijfsbeheer en sollicitatieprocessen worden gestroomlijnd en gecentraliseerd met behulp van PHP en Laravel.',
        technologies: ['PHP', 'HTML', 'CSS', 'JavaScript', 'TailwindCSS'],
        projectDetails: [
            'Ons team heeft een platform ontwikkeld voor Job Application Training in opdracht van een externe docent, om het jaarlijkse IT-studentenstageprogramma van Thomas More College te vereenvoudigen en te centraliseren. Het project werd uitgevoerd door een team van zes studenten, bestaande uit een teamleider, een document lead en vier developers.',
            'Onze opdrachtgever beheerde het proces oorspronkelijk volledig met Excel-spreadsheets en handmatige acties. Dit veroorzaakte elk jaar problemen bij het coördineren van de stages voor studenten, totdat wij een oplossing mochten bouwen om dit proces te automatiseren. Dit platform is ontworpen om zowel studenten als bedrijven te ondersteunen via een gebruiksvriendelijke en centrale applicatie.',
            'De applicatie biedt verschillende functies zoals bedrijfsregistratie, waarmee coördinatoren een lijst van deelnemende partnerbedrijven eenvoudig kunnen beheren. Daarnaast is er een studentregisatiefunctie ontwikkeld, waarmee coördinatoren studenten kunnen registreren en beheren. Studenten kunnen vervolgens bedrijfsinformatie zien en aangeven bij welk bedrijf ze graag stage zouden willen lopen.',
            'Een andere belangrijke functionaliteit is de mogelijkheid voor studenten om zelf tijdslots te boeken voor interviews met gekozen bedrijven. Na afloop kunnen studenten feedback geven over hun ervaring via een feedbackformulier. Hiermee vervangt de applicatie diverse gebruikte softwareprogramma’s en biedt het een gecentraliseerd platform dat alle aspecten van het programma efficiënter beheert.',
            'Tijdens het project hebben we veel geleerd, zoals het samenwerken in een team volgens real-life workflows, met sprintweken, stand-ups en het oplossen van diverse problemen. Daarnaast hebben we diepgaand geleerd te werken met PHP en Laravel, en ervaren hoeveel mogelijkheden dit biedt in vergelijking met standaard HTML en JavaScript.',
            'Het project was een schoolopdracht en staat daarom niet meer online, maar er zijn afbeeldingen beschikbaar met beschrijvingen van het platform. Voor geïnteresseerden is het volledige analyse- en ontwerpverslag ook beschikbaar.'
        ],
        projectImages: [
            require('@/assets/images/Projects/project-4/home.png'),
            require('@/assets/images/Projects/project-4/files.png'),
            require('@/assets/images/Projects/project-4/timeslots.png'),
        ],
        files: [
            {
                name: `Meer foto's van het project`,
                url: 'https://imgur.com/a/1siIwok'
            },
            {
                name: `Analyse en ontwerpverslag`,
                url: '/files/Analysis_and_Design_Report_DDP-D.pdf'
            },
        ]
    },
    {
        id: 5,
        title: 'Staff Management System',
        category: 'Requirements Analysis',
        img: require('@/assets/images/Projects/project-5/staff-management.png'),
        date: '2022 - 2023',
        client: {
            name: 'Thomas More',
            services: 'Requirement Analysis',
        },
        objective: "Het analyseren van vereisten en ontwerpen van een huishoudelijk beheersysteem gericht op het centraliseren van personeelsbeheer, het plannen van huishoudtaken en het bijhouden van facturen en schema's, rekening houdend met diverse behoeften.",
        technologies: ['Axure'],
        projectDetails: [
            'Het Requirements Analysis-project werd uitgevoerd voor een externe docent, die behoefte had aan een personeelsbeheersysteem voor haar huishouden. Het systeem moest taken zoals het beheren van huishoudelijk personeel, plannen van kinderopvang en het bijhouden van huiswerkzaamheden vereenvoudigen. Ons team bestond uit 4 developers, een document lead en mezelf, Sian Lauwers (Project Lead).',
            'Het doel van dit project was om een applicatie te ontwerpen waarmee au-pairs en huishoudpersoneel eenvoudig hun planning, takenlijsten en facturen op één centrale plaats konden beheren. Dit zou helpen om de organisatie te stroomlijnen, aangezien deze zaken momenteel verspreid worden bijgehouden in papieren documenten, e-mails en andere losse systemen. Daarnaast moest het systeem ook maaltijden plannen en rekening houden met de behoeften van een autistische kleinzoon die de grootouders regelmatig bezoekt. Met een overzicht van wie wanneer werkt en wat er wordt gegeten, kon hij zijn bezoeken beter plannen.',
            'Ons team begon met het verzamelen van informatie over de behoeften, doelen en verwachtingen van de opdrachtgever. We ontwikkelden datamodellen om de entiteiten, attributen en relaties binnen het systeem te visualiseren, evenals de bedrijfsregels die deze govern. Dit hielp om de basis van het systeem te definiëren.',
            'Tijdens het project hebben we nauw samengewerkt met de opdrachtgever om ervoor te zorgen dat het systeem gebruiksvriendelijk, veilig en schaalbaar was. We hebben ook rekening gehouden met de benodigde technische infrastructuur, waaronder hardware, software en netwerkvereisten. Onze documentatie en prototypes dienden als basis voor een toekomstig ontwikkelteam dat verantwoordelijk was voor het bouwen en uitrollen van het eindproduct.',
            'Het resultaat van dit project was een succesvol afgeronde vereistenanalyse en onze opdrachtgever was erg tevreden met het resultaat. De functies van het systeem richtten zich op personeelsbeheer, planningen, takenlijsten, facturen en maaltijden. Onze aanpak hield rekening met zowel algemene organisatorische behoeften als specifieke vereisten, zoals het ondersteunen van een kleinzoon met autisme.',
            'Ik heb hier leren omgaan met verschillende rollen en taken. Ik heb ook geleerd om te communiceren met de opdrachtgever en om hun behoeften te begrijpen en te voldoen. Dit project heeft mij geholpen om mijn vaardigheden in het analyseren van vereisten en het ontwerpen van systemen te verbeteren. Ik heb ook geleerd om te werken in een team en om samen te werken met andere professionals om een succesvolle oplossing te ontwikkelen.',
            'Na afronding van het project hebben we alle documentatie en prototypes overgedragen aan het volgende team dat verantwoordelijk was voor de ontwikkeling en publicatie van de uiteindelijke applicatie. Je kunt het Analyse- en ontwerpverslag bekijken, evenals de door ons gemaakte prototypes.'
        ],
        projectImages: [
            require('@/assets/images/Projects/project-5/Diagram.png'),
            require('@/assets/images/Projects/project-5/Home.png'),
            require('@/assets/images/Projects/project-5/To-do.png'),
        ],
        files: [
            {
                name: `Prototypes`,
                url: 'https://b2tdnu.axshare.com/?id=j1oj2a'
            },
            {
                name: `Analyse en ontwerpverslag`,
                url: '/files/Analysis_and_Design_Report_LST3.pdf'
            },
        ]
    },
    {
        id: 6,
        title: 'Space Shooter Game',
        category: 'DevOps & Security Case Study',
        img: require('@/assets/images/Projects/project-6/Cover.png'),
        date: '2022',
        client: {
            name: 'Thomas More',
            services: 'Game Development Case Study',
        },
        objective: 'Het ontwikkelen van een Space Shooter game als case study voor de cursus DevOps & Security, met focus op WPF development en software engineering principes.',
        technologies: ['C#', 'Devops'],
        projectDetails: [
            'Voor de cursus DevOps & Security koos ik ervoor om een Space Shooter game te ontwikkelen in WPF. Deze case study bood de perfecte gelegenheid om verschillende aspecten van software ontwikkeling in praktijk te brengen.',
            'De game draait in een venster van 615x540 pixels, met een canvas als hoofdspeelveld. De speler bestuurt een ruimteschip met de pijltjestoetsen en kan schieten met de spatiebalk. Het scoringsysteem houdt zowel de huidige score als de hoogste score bij.',
            'Technische implementaties omvatten:',
            '• Een game loop systeem voor continue spelverwerking',
            '• Collision detection tussen kogels en vijanden',
            '• Dynamische moeilijkheidsgraad die toeneemt naarmate het spel vordert',
            '• Vijf verschillende type vijanden met random spawning mechanisme',
            'Hoewel de beschikbare tijd beperkt was, heb ik veel geleerd over WPF development en game mechanics.',
            'Deze case study heeft waardevolle inzichten opgeleverd in game development principes en WPF-programmering binnen een academische context. Ook heb ik hier geleerd hoe een CI/CD pipeline kan worden opgezet en gebruikt om de software te testen en te implementeren.',
        ],
        projectImages: [
            require('@/assets/images/Projects/project-6/Cover.png'),
            require('@/assets/images/Projects/project-6/devops.jpg'),
            require('@/assets/images/Projects/project-6/Game.png'),
        ],
        files: [
            {
                name: 'Github Repository',
                url: 'https://github.com/SianLauwers/SpaceShooterGame'
            },
            {
                name: 'Video',
                url: 'https://youtu.be/g7w_Nz2RWJA?si=3ZJa21BhbzAzKPcu'
            },
        ]
    },
    {
        id: 7,
        title: 'Cegeka Recruitment Process Analysis',
        category: 'Business Process Analysis',
        img: require('@/assets/images/Projects/project-7/Organisation-Chart.png'),
        date: '2022',
        client: {
            name: 'Thomas More',
            services: 'Business Process Analysis',
        },
        objective: 'Het analyseren en modelleren van het recruitmentproces bij Cegeka als onderdeel van de cursus Business Processes en ITIL, met focus op procesoptimalisatie en BPMN-modellering.',
        technologies: ['Bizagi', 'BPMN', 'Process Modeling'],
        projectDetails: [
            'Als onderdeel van een team van 4 studenten hebben we een diepgaande analyse uitgevoerd van het recruitmentproces bij Cegeka, een toonaangevend Europees IT-bedrijf met ongeveer 5000 medewerkers.',
            'Mijn bijdrage aan dit project omvatte het initiële contact leggen met Cegeka en het ontwikkelen van de BPMN-modellen samen met mijn teamgenoten. We hebben nauw samengewerkt met een Campus recruitment officer bij Cegeka.',
            'Het project bestond uit verschillende fasen:',
            '• Een diepgaand interview met de recruitment officer',
            '• Het modelleren van het volledige recruitmentproces in Bizagi',
            '• Analyse van het huidige proces en identificatie van verbeterpunten',
            '• Het opstellen van concrete aanbevelingen voor procesoptimalisatie',
            'We hebben het volledige recruitmentproces in kaart gebracht, van de initiële vacatureopstelling tot de eerste werkdag van nieuwe medewerkers. Onze analyse omvatte verschillende aspecten zoals sollicitatiegesprekken, technische assessments en het onboardingproces.',
            'Het project heeft geleid tot verschillende verbetervoorstellen, waaronder het stroomlijnen van het sollicitatieproces en het optimaliseren van de planning van technische assessments.',
            'Hier heb ik voor het eerste kennis gemaakt met de bedrijfscultuur. Ook heb ik geleerd om een BPMN-model te maken en het proces te visualiseren, waardoor ik mijn kennis van BPMN-modellering en procesoptimalisatie heb verdiept.',
            'Ik ben Cegeka zeer dankbaar voor deze leerzame ervaring en de mogelijkheid om hun recruitmentproces te analyseren. Het bezoek aan hun hoofdkantoor op de Corda Campus in Hasselt gaf mij daarnaast een waardevol inzicht in hun bedrijfscultuur.'
        ],
        projectImages: [
            require('@/assets/images/Projects/project-7/cegeka-logo.jpg'),
            require('@/assets/images/Projects/project-7/Team.png'),
            require('@/assets/images/Projects/project-7/Organisation-Chart.png'),
        ],
        files: [
            {
                name: 'Project Video',
                url: 'https://youtu.be/VNEqXFgQwrs'
            },
            {
                name: 'BPMN Model',
                url: '/files/BPMN-Model.pdf'
            },
            {
                name: 'BPMN Report',
                url: '/files/Report-BPMN-Cegeka.pdf'
            }
        ]
    },
];

export default projects;
